import { equals } from 'ramda';
import { useMemo } from 'react';
import { useUrlParams } from '../../hooks/useUrlParams';
import { transformLegacyPLPQueryParams } from './transformLegacyPLPQueryParams';

export const useRedirectLegacyPLPQueryParams = () => {
  const { params, setParams } = useUrlParams();
  const transformedParams = useMemo(() => transformLegacyPLPQueryParams(params), [params]);
  const shouldRedirect = useMemo(
    () => !equals(params, transformedParams),
    [params, transformedParams]
  );

  if (shouldRedirect) setParams(transformedParams, { replace: true });
};
